import { produce } from 'immer';
import { ASK_REVERIFY_EMAIL_ACCOUNT_FROM_INBOUND, CLEAR_REVERIFY_STATE, SET_IS_REVERIFY_ACTION_PENDING, SET_REVERIFY_NEW_EMAIL_VERIFICATION_SENT_FROM_INBOUND, SET_REVERIFY_PAGE } from '../actions/reverifyActions';
const initialState = {};
const reverifyReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_REVERIFY_STATE: {
                return initialState;
            }
            case ASK_REVERIFY_EMAIL_ACCOUNT_FROM_INBOUND: {
                const { username, currentEmail } = action.payload;
                draft.page = 'ask';
                draft.username = username;
                draft.currentEmail = currentEmail;
                break;
            }
            case SET_REVERIFY_PAGE: {
                delete draft.isActionPending;
                draft.page = action.payload;
                break;
            }
            case SET_IS_REVERIFY_ACTION_PENDING: {
                draft.isActionPending = action.payload;
                break;
            }
            case SET_REVERIFY_NEW_EMAIL_VERIFICATION_SENT_FROM_INBOUND: {
                delete draft.isActionPending;
                draft.page = 'new-email-verification-sent';
                draft.newEmail = action.payload.newEmail;
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default reverifyReducer;
